import React from "react";
import styled from "styled-components";
import Text from "./Text";
import Icon from "./Icon";
import { CHECK } from "../icons";
import * as colors from "../settings/colors";
import { getCurrentProductionStep } from "../utils/helpers";

const Label = styled.span`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const ServiceProductionStatus = ({ service }) => {
  const { job, productionSteps, currentProductionStep } = service;
  if (!productionSteps) return null;
  let currentStep = currentProductionStep || getCurrentProductionStep(service);

  if (currentStep) {
    const started = currentStep.action === "complete";
    return (
      <div>
        <Label>{started ? "Currently" : "Up Next"}</Label>
        <br />
        {currentStep.info.name}
        {started &&
          currentStep.user && (
            <Text muted>
              <br />
              {currentStep.user.name}
            </Text>
          )}
      </div>
    );
  }

  return <Icon icon={CHECK} color={colors.GREEN} />;
};

export default ServiceProductionStatus;



// WEBPACK FOOTER //
// ./src/components/ServiceProductionStatus.js